const emoTextList = ['大笑', '同意', '点赞', '尬笑', '笑哭', '温和', '无语', '挑眉', '腼腆', '天使',
	'喜欢', '心动', '憧憬', '示爱', '亲亲', '惬意', '亲吻', '苦笑', '美味', '吐舌',
	'搞怪', '憨趣', '拜金', '捧脸', '捂嘴', '噤声', '思考', '封嘴', '疑惑', '漠然',
	'狡黠', '蹙眉', '错愕', '咬牙', '撒谎', '舒心', '低落', '打盹', '流涎', '休憩',
	'防护', '测温', '负伤', '作呕', '呕吐', '流涕', '冒汗', '冻僵', '眩晕', '晕厥',
	'炸脑', '牛仔', '欢庆', '大叔', '得意', '考究', '不悦', '愁苦', '失落', '惊讶',
	'吃惊', '愕然', '瞠目', '委屈', '惶恐', '难堪', '心酸', '落泪', '大哭', '惊惧',
	'难受', '苦恼', '消沉', '汗颜', '悲叹', '掩饰', '气愤', '生气', '愤懑', '腹黑',
	'嗔怪', '怒骂', '便便', '小丑', '恶鬼', '天狗', '幽灵', '外星', '虫怪', '骷髅'
];

const legacyEmoTextList = ['憨笑', '媚眼', '开心', '坏笑', '可怜', '爱心', '笑哭', '拍手', '惊喜', '打气',
	'大哭', '流泪', '饥饿', '难受', '健身', '示爱', '色色', '眨眼', '暴怒', '惊恐',
	'思考', '头晕', '大吐', '酷笑', '翻滚', '享受', '鼻涕', '快乐', '雀跃', '微笑',
	'贪婪', '红心', '粉心', '星星', '大火', '眼睛', '音符', '叹号', '问号', '绿叶',
	'燃烧', '喇叭', '警告', '信封', '房子', '礼物', '点赞', '举手', '喝彩', '点头',
	'摇头', '偷瞄', '庆祝', '疾跑', '打滚', '惊吓', '起跳'
];

const findEmojiUrl = (word) => {
	const idx = emoTextList.indexOf(word);
	if (idx !== -1) {
		return require(`@/assets/emoji2/${idx}.png`);
	}

	const legacyIdx = legacyEmoTextList.indexOf(word);
	if (legacyIdx !== -1) {
		return require(`@/assets/emoji/${legacyIdx}.gif`);
	}
	return '';
}

let transform = (content, extClass) => {
	return content.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, (text) => textToImg(text, extClass));
}

// 将匹配结果替换表情图片
let textToImg = (emoText, extClass) => {
	let word = emoText.replace(/\#|\;/gi, '');
	let url = findEmojiUrl(word);
	if (!url) {
		return emoText;
	}
	return `<img src="${url}" class="${extClass}" />`
}

let textToUrl = (emoText) => {
	let word = emoText.replace(/\#|\;/gi, '');
	return findEmojiUrl(word);
}

export default {
	emoTextList,
	transform,
	textToImg,
	textToUrl
}
